import { CircularProgress } from './CircularProgress';

export function LoadingIndicator() {
  return (
    <div className={'flex justify-center p-8'}>
      <CircularProgress size={'lg'} />
    </div>
  );
}